import { useEffect, useState } from 'react';
import styles from './pages.module.css';
import Card from '../../components/Card/Card';
import SportModul from '../../components/SportModul/SportModul';   // ⬅️ from the previous answer
import { fetchModulesByCategory } from '../../../code/SportModuleLoader';
import HeroBanner from '../../components/HeroBanner/HeroBanner';
const FitnessEntspannung = () => {
    const [hasImages, setHasImages] = useState(false);
    const [modules, setModule] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        fetchModulesByCategory('fitness-und-entspannung', setModule);
        setLoading(false);
    }, []);
    if (loading) {
        return (
            <div></div>
        )
    }
    return (
        <div>
            <HeroBanner category="fitness-und-entspannung" onImagesLoaded={setHasImages} />
            <section
                className={styles.container}
                style={{ marginTop: hasImages ? '20px' : 'var(--marginTopDefault)' }}        >
                <h1>Fitness und Entspannung</h1>
                <section>
                    <div className={styles.modulesContainer}>
                        {/* --- ALL cards come from the array -------------------------------- */}
                        {modules.map((modul, index) => (
                            <Card
                                key={index}
                                id={modul.anchor_id}
                                icon={`${process.env.PUBLIC_URL}${modul.iconPath || modul.icon_path}`}
                                iconText={modul.iconText}
                                title={modul.title}
                                rightText={modul.class || ''}
                            >
                                <SportModul modul={modul} />
                            </Card>
                        ))}
                    </div>
                </section>
            </section>
        </div>

    );
};

export default FitnessEntspannung;
